import t from "utils/translate";
import {
  CLINICAL_PROGRAM,
  CORE_PRODUCT,
  DIABETES_PROGRAM,
  DIABETES_WORKSHOP_PROGRAM,
  GLP1_PROGRAM,
  GLP1_WORKSHOP_PROGRAM,
  PREMIUM_PRODUCT
} from "utils/resultFunctions/constants";
import { whyLoseWeight as whyLoseWeightUtils } from "utils/whyLoseWeight";

import useAppContext from "components/AppContext";
import { getWeightLossChartData } from "components/Profile/utils/getWeightLossResults";

import styles from "./styles.module.scss";

export const ResultsChecklist: React.FC<{ resultsScreen: string }> = ({
  resultsScreen
}) => {
  const { profile, answers, assessment } = useAppContext();

  const checklistHeader = {
    [CORE_PRODUCT]: t("RESULTS_CHECKLIST_HEADER"),
    [PREMIUM_PRODUCT]: t("RESULTS_CHECKLIST_HEADER"),
    [DIABETES_PROGRAM]: t("RESULTS_CHECKLIST_HEADER"),
    [DIABETES_WORKSHOP_PROGRAM]: t("RESULTS_CHECKLIST_HEADER"),
    [GLP1_PROGRAM]: t("RESULTS_CHECKLIST_HEADER"),
    [GLP1_WORKSHOP_PROGRAM]: t("RESULTS_CHECKLIST_HEADER"),
    [CLINICAL_PROGRAM]: t("SEQUENCE_FEATURES_HEADING")
  };

  const { weightLoss } = getWeightLossChartData({
    profile,
    showClinicalChart: [
      CLINICAL_PROGRAM,
      GLP1_PROGRAM,
      GLP1_WORKSHOP_PROGRAM
    ].includes(resultsScreen)
  });

  const whyLoseWeight = whyLoseWeightUtils(
    answers,
    assessment?.questions || []
  );

  const checklistItems = {
    [CORE_PRODUCT]: [
      t("RESULTS_CHECKLIST_POINTS_1"),
      t("RESULTS_CHECKLIST_POINTS_2"),
      t("RESULTS_CHECKLIST_3", {
        weightLoss: weightLoss,
        whyLoseWeight: whyLoseWeight
      })
    ],
    [PREMIUM_PRODUCT]: [
      t("RESULTS_CHECKLIST_POINTS_1"),
      t("RESULTS_CHECKLIST_POINTS_2"),
      t("RESULTS_CHECKLIST_3", {
        weightLoss: weightLoss,
        whyLoseWeight: whyLoseWeight
      })
    ],
    [DIABETES_PROGRAM]: [
      t("RESULTS_CHECKLIST_DIABETES_1"),
      t("RESULTS_CHECKLIST_DIABETES_2"),
      t("RESULTS_CHECKLIST_3", {
        weightLoss: weightLoss,
        whyLoseWeight: whyLoseWeight
      })
    ],
    [DIABETES_WORKSHOP_PROGRAM]: [
      t("RESULTS_CHECKLIST_DIABETES_1"),
      t("RESULTS_CHECKLIST_DIABETES_2"),
      t("RESULTS_CHECKLIST_3", {
        weightLoss: weightLoss,
        whyLoseWeight: whyLoseWeight
      })
    ],
    [GLP1_PROGRAM]: [
      t("RESULTS_CHECKLIST_GLP1_1"),
      t("RESULTS_CHECKLIST_GLP1_2"),
      t("RESULTS_CHECKLIST_3", {
        weightLoss: weightLoss,
        whyLoseWeight: whyLoseWeight
      })
    ],
    [GLP1_WORKSHOP_PROGRAM]: [
      t("RESULTS_CHECKLIST_GLP1_1"),
      t("RESULTS_CHECKLIST_GLP1_2"),
      t("RESULTS_CHECKLIST_3", {
        weightLoss: weightLoss,
        whyLoseWeight: whyLoseWeight
      })
    ],
    [CLINICAL_PROGRAM]: [
      t("RESULTS_CHECKLIST_CLINICAL_1"),
      t("RESULTS_CHECKLIST_CLINICAL_2"),
      t("RESULTS_CHECKLIST_3", {
        weightLoss: weightLoss,
        whyLoseWeight: whyLoseWeight
      })
    ]
  };

  return (
    <div className={styles.checklist}>
      <div className={styles.header}>{checklistHeader[resultsScreen]}</div>
      <div className={styles.list}>
        {checklistItems[resultsScreen].map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.number}>{index + 1}</div>
            <div className={styles.text}>{item}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
